import { MySection } from '@/components/custom/my-section';
import { Separator } from '@/components/ui/separator';
import { Stack, Typography } from '@mui/material';

interface SummarySectionProps {
  subtotal: number;
  tax: number;
  taxIncl: number;
  total: number;
  paymentTotal: number;
  outstandingBalance: number;
  deliveryTotal: number;
}

export function SummarySection({
  subtotal,
  tax,
  taxIncl,
  total,
  paymentTotal,
  outstandingBalance,
  deliveryTotal,
}: SummarySectionProps) {
  return (
    <MySection title="Summary">
      <Stack spacing={2}>
        {/* Cost Breakdown */}
        <Stack spacing={1}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Subtotal:
            </Typography>
            <Typography variant="body2">${subtotal.toFixed(2)}</Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Tax:
            </Typography>
            <Typography variant="body2">${tax.toFixed(2)}</Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Delivery Total:
            </Typography>
            <Typography variant="body2">${deliveryTotal.toFixed(2)}</Typography>
          </Stack>
        </Stack>

        <Separator />

        {/* Total */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1" fontWeight="bold">
            Total:
          </Typography>
          <Typography variant="subtitle1" fontWeight="bold">
            ${total.toFixed(2)}
          </Typography>
        </Stack>

        <Separator />

        {/* Payment Status */}
        <Stack spacing={1}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Payment Total:
            </Typography>
            <Typography variant="body2">${paymentTotal.toFixed(2)}</Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Outstanding Balance:
            </Typography>
            <Typography
              variant="body2"
              fontWeight="medium"
              color={outstandingBalance > 0 ? "error.main" : "text.primary"}
            >
              ${outstandingBalance.toFixed(2)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </MySection>
  );
}
